<template>
  <div class="swiper-slide panel-item">
    <a :href="url" target="_blank" rel="nofollow">
      <div class="panel-header">
        <template v-if="isLazy">
          <img :data-src="eat.image_url" :alt="eat.name" class="swiper-lazy" />
          <div class="swiper-lazy-preloader"></div>
        </template>
        <template v-else>
          <img :src="eat.image_url" :alt="eat.name" />
        </template>
      </div>
      <div class="panel-body">
        <kcs-area-label
          :prefecture="eat.prefecture"
          :city="eat.city"
          :facility-type="eat.facility_type"
        />
        <h3 class="panel-name">
          {{ eat.name }}
          <img
            src="//ad.jp.ap.valuecommerce.com/servlet/gifbanner?sid=3587605&pid=887185949"
            height="1"
            width="0"
            border="0"
            class="ad-img"
          />
        </h3>
        <p class="panel-lead hide-sp">{{ eat.introduction }}</p>
        <p class="btn-wrapper">
          <span class="btn fac">このお店を詳しく見る</span>
        </p>
      </div>
    </a>
  </div>
</template>

<script>
import KcsAreaLabel from '@/components/atoms/kcs-area-label.vue'
export default {
  components: {
    KcsAreaLabel
  },
  props: {
    eat: {
      type: Object,
      required: true
    },
    isLazy: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    url() {
      if (!this.eat.place_url) return ''
      const hotpepperRegex = /https:\/\/www.hotpepper.jp\/strJ[0-9]+\//
      const hotpepperUrl = this.eat.place_url.match(hotpepperRegex)
      if (hotpepperUrl) {
        hotpepperUrl[0] += '?vos=nhppvccp99002'
        return (
          'https://ck.jp.ap.valuecommerce.com/servlet/referral' +
          '?sid=3587605' +
          '&pid=887185949' +
          '&vc_url=' +
          this.$options.filters.urlencode(hotpepperUrl[0])
        )
      } else {
        return this.eat.place_url
      }
    }
  }
}
</script>
